import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import "moment/locale/fr";
import {
  addCandidateExperience,
  deleteCandidateExperience,
  updateCandidateExperience,
} from "../../../redux/actions/admin/CandidateActions";
import moment from "moment";
import "moment/locale/fr";
import { CircularProgress } from "@material-ui/core";
import localStorageService from "../../../services/localStorageService";
import isMatch from "date-fns/isMatch";
import { types } from "../../shared/Helper";
import Select from "react-select";

let ExperienceReume = (props) => {
  const {
    experienceList,
    addCandidateExperience,
    deleteCandidateExperience,
    updateCandidateExperience,
  } = props;

  const closeDeleteExperienceModal = React.useRef();
  const [
    displayingCandidateExperienceList,
    setDisplayCandidateExperienceList,
  ] = React.useState([]);
  const [invalideDate, setInvalideDate] = React.useState(false);
  const [showExperienceForm, setShowExperienceForm] = React.useState(false);
  const [showUpdateForm, setShowUpdateForm] = React.useState({});
  const [isExperienceAdding, setIsExperienceAdding] = React.useState(false);
  const [isExperienceUpdating, setIsExperienceUpdating] = React.useState(false);
  const [isExperienceDeletting, setIsExperienceDeletting] = React.useState(
    false
  );
  const [published, setPublished] = React.useState(false);
  const [experienceTodelete, setExperienceTodelete] = React.useState(null);
  const [candidate, setCandidate] = React.useState(null);
  const [newExperience, setNewExperience] = React.useState({
    id: "",
    title: "",
    companyName: "",
    jobType: "",
    startDate: "",
    endDate: "",
    description: "",
  });
  const [experienceToUpdate, setExperienceToUpdate] = React.useState({});

  useEffect(() => {
    if (experienceList !== null) {
      setDisplayCandidateExperienceList(experienceList);
    }
  }, [experienceList]);

  const toggleForm = () => {
    setShowExperienceForm(!showExperienceForm);
  };

  const toggleUpdateForm = (experience) => {
    setExperienceToUpdate(experience);
    setShowUpdateForm((prevState) => ({
      ...prevState,
      [experience.id]: !prevState[experience.id],
    }));
  };

  const handleCreateExperienceSubmit = async () => {
    setIsExperienceAdding(true);
    let experience = newExperience;
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    experience.candidateId = candidate.id;

    try {
      const data = await addCandidateExperience(experience);
      if (data.success) {
        setDisplayCandidateExperienceList(data.candidate.workExperiences);
        setCandidate(data.candidate);
        clearExperienceForm();
      }
      setIsExperienceAdding(false);
      setPublished(true);
      setShowExperienceForm(false);
    } catch (error) {
      setIsExperienceAdding(false);
    }
  };
  const clearExperienceForm = () => {
    setNewExperience({
      id: "",
      title: "",
      companyName: "",
      jobType: "",
      startDate: "",
      endDate: "",
      description: "",
    });
  };
  const handleUpdateExperienceSubmit = () => {
    setIsExperienceUpdating(true);
    let experience = experienceToUpdate;
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    experience.candidateId = candidate.id;

    updateCandidateExperience(experience).then((data) => {
      if (data.success) {
        setDisplayCandidateExperienceList(data.candidate.workExperiences);
        setCandidate(data.candidate);
      }
      setIsExperienceUpdating(false);
      setPublished(false);
      toggleUpdateForm(experience);
    });
  };

  const handleDeleteExperienceSubmit = () => {
    setIsExperienceDeletting(true);
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    deleteCandidateExperience(candidate?.id, experienceTodelete.id).then(
      (resp) => {
        if (resp.success == true) {
          setDisplayCandidateExperienceList(resp.candidate.workExperiences);
          setCandidate(resp.candidate);
        }
        setExperienceTodelete("");
        closeDeleteExperienceModal.current.click();
        setIsExperienceDeletting(false);
      }
    );
  };

  return (
    <React.Fragment>
      <div className="bg-light-3 p-4">
        <div className="row">
          <div className="col-md-7 col-sm-5 d-flex align-items-center">
            <div className="section-title mb-0 ">
              <h3 className="title mb-0">
                {" "}
                <span>Expérience Professionnelle</span>
              </h3>
            </div>
          </div>
          <div
            className="col-md-5 col-sm-7 mt-3 mt-sm-0 pr-3"
            style={{ textAlign: "right" }}
          >
            <button className="btn btn-primary" onClick={toggleForm}>
              Ajouter une Expérience
            </button>
          </div>
        </div>
        <div className="row">
          {showExperienceForm == true && (
            <div className="col-xl-12">
              <div className="mt-4">
                <div className="bg-light-3">
                  <div _lpchecked="1">
                    <div className="form-row">
                      <div className="form-group col-md-12">
                        <label>Titre </label>
                        <input
                          value={newExperience.title}
                          type="text"
                          className="form-control"
                          id="title"
                          onChange={(e) => {
                            let val = e.target?.value;
                            setNewExperience((prevState) => {
                              return { ...prevState, title: val };
                            });
                          }}
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label>Nom de la société </label>
                        <input
                          value={newExperience.companyName}
                          type="text"
                          className="form-control"
                          id="companyName"
                          onChange={(e) => {
                            let val = e.target?.value;
                            setNewExperience((prevState) => {
                              return { ...prevState, companyName: val };
                            });
                          }}
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label>Type de travail </label>
                        <Select
                          value={types.find(
                            (opt) => opt.value == newExperience.jobType
                          )}
                          options={types}
                          id="jobType"
                          onChange={(e) => {
                            let val = e.value;
                            setNewExperience((prevState) => {
                              return { ...prevState, jobType: val };
                            });
                          }}
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label>De</label>
                        <input
                          value={moment(newExperience.startDate)?.format(
                            "YYYY-MM-DD"
                          )}
                          type="date"
                          className="form-control"
                          id="startDate"
                          placeholder=""
                          onChange={(e) => {
                            let val = e.target?.value;
                            let match = isMatch(e.target.value, "yyyy-MM-dd");
                            setNewExperience((prevState) => {
                              return {
                                ...prevState,
                                startDate: val,
                              };
                            });
                            if (match && val != "") {
                              setInvalideDate(!match);
                            }
                          }}
                          onBlur={(e) => {
                            let val = isMatch(e.target.value, "yyyy-MM-dd");
                            if (e.target.value != "") {
                              setInvalideDate(!val);
                            }
                            if (!val) {
                              setNewExperience((prevState) => {
                                return {
                                  ...prevState,
                                  startDate: "",
                                };
                              });
                            }
                          }}
                        />
                        {invalideDate && (
                          <p style={{ color: "red" }}>Format invalide</p>
                        )}
                      </div>
                      <div className="form-group col-md-6">
                        <label>À</label>
                        <input
                          value={moment(newExperience.endDate)?.format(
                            "YYYY-MM-DD"
                          )}
                          type="date"
                          className="form-control"
                          id="endDate"
                          placeholder=""
                          onChange={(e) => {
                            let val = e.target?.value;
                            let match = isMatch(e.target.value, "yyyy-MM-dd");
                            setNewExperience((prevState) => {
                              return {
                                ...prevState,
                                endDate: val,
                              };
                            });
                            if (match && val != "") {
                              setInvalideDate(!match);
                            }
                          }}
                          onBlur={(e) => {
                            let val = isMatch(e.target.value, "yyyy-MM-dd");
                            if (e.target.value != "") {
                              setInvalideDate(!val);
                            }
                            if (!val) {
                              setNewExperience((prevState) => {
                                return {
                                  ...prevState,
                                  endDate: "",
                                };
                              });
                            }
                          }}
                        />
                        {invalideDate && (
                          <p style={{ color: "red" }}>Format invalide</p>
                        )}
                      </div>

                      <div className="form-group col-md-12">
                        <label>Description</label>
                        <textarea
                          value={newExperience.description}
                          type="text"
                          className="form-control"
                          id="description"
                          placeholder=""
                          onChange={(e) => {
                            let val = e.target?.value;
                            setNewExperience((prevState) => {
                              return { ...prevState, description: val };
                            });
                          }}
                        ></textarea>
                      </div>
                      <div className="col-12 mt-4">
                        <button
                          className="btn btn-primary"
                          onClick={handleCreateExperienceSubmit}
                          disabled={isExperienceAdding}
                          style={{ textAlign: "right", float: "right" }}
                        >
                          Ajouter &nbsp;{" "}
                          {isExperienceAdding ? (
                            <CircularProgress size={15} />
                          ) : (
                            <span></span>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="row">
          <div className="col-xl-12 mt-4">
            {displayingCandidateExperienceList?.length !== 0 && (
              <div className="timeline-box bg-white p-3 ">
                <div className="jobster-candidate-timeline">
                  <div className="jobster-timeline-icon">
                    <i className="fas fa-briefcase"></i>
                  </div>

                  {displayingCandidateExperienceList?.map(
                    (experience, index) => (
                      <div className="jobster-timeline-item" key={index}>
                        <div className="jobster-timeline-cricle">
                          <i className="far fa-circle"></i>
                        </div>
                        <div className="jobster-timeline-info">
                          <div className="dashboard-timeline-info">
                            <div className="row">
                              <div className="col-12">
                                <div className="row">
                                  <div className="col-12">
                                    <div className="row">
                                      <div className="col-10">
                                        <span className="jobster-timeline-time">
                                          {moment(experience.startDate).format(
                                            "DD-MMMM-YYYY"
                                          )}{" "}
                                          à{" "}
                                          {moment(experience.endDate).format(
                                            "DD-MMMM-YYYY"
                                          )}
                                        </span>
                                      </div>
                                      <div className="col-2">
                                        <div className="dashboard-timeline-edit">
                                          <ul className="list-unstyled mb-0 d-flex justify-content-end">
                                            <li className="pr-2">
                                              <a
                                                href="javascript:void(0)"
                                                onClick={() =>
                                                  toggleUpdateForm(experience)
                                                }
                                              >
                                                <i className="fas fa-pencil-alt"></i>
                                              </a>
                                            </li>
                                            <li>
                                              <a
                                                href="#"
                                                className="text-danger"
                                                data-toggle="modal"
                                                title=""
                                                data-target="#deleteExperience"
                                                data-original-title="Delete"
                                              >
                                                <i
                                                  className="far fa-trash-alt text-danger"
                                                  onClick={() =>
                                                    setExperienceTodelete(
                                                      experience
                                                    )
                                                  }
                                                ></i>
                                              </a>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>

                                    <h6 className="mb-2">{experience.title}</h6>
                                    <span>- {experience.companyName}</span>
                                    <p className="mt-2">
                                      {experience.description}
                                    </p>
                                  </div>
                                  {showUpdateForm[experience.id] && (
                                    <div className="col-12">
                                      <div className="mt-4">
                                        <div className="bg-light-3 p-4">
                                          <div _lpchecked="1">
                                            <div className="form-row">
                                              <div className="form-group col-md-12">
                                                <label>Titre </label>
                                                <input
                                                  value={
                                                    experienceToUpdate.title
                                                  }
                                                  type="text"
                                                  className="form-control"
                                                  id="title"
                                                  onChange={(e) => {
                                                    let val = e.target?.value;
                                                    setExperienceToUpdate(
                                                      (prevState) => {
                                                        return {
                                                          ...prevState,
                                                          title: val,
                                                        };
                                                      }
                                                    );
                                                  }}
                                                />
                                              </div>
                                              <div className="form-group col-md-6">
                                                <label>
                                                  Nom de la société{" "}
                                                </label>
                                                <input
                                                  value={
                                                    experienceToUpdate.companyName
                                                  }
                                                  type="text"
                                                  className="form-control"
                                                  id="companyName"
                                                  onChange={(e) => {
                                                    let val = e.target?.value;
                                                    setExperienceToUpdate(
                                                      (prevState) => {
                                                        return {
                                                          ...prevState,
                                                          companyName: val,
                                                        };
                                                      }
                                                    );
                                                  }}
                                                />
                                              </div>
                                              <div className="form-group col-md-6">
                                                <label>Type de travail </label>
                                                <Select
                                                  value={types.find(
                                                    (opt) =>
                                                      opt.value ===
                                                      experienceToUpdate.jobType
                                                  )}
                                                  options={types}
                                                  id="jobType"
                                                  onChange={(
                                                    selectedOption
                                                  ) => {
                                                    let val =
                                                      selectedOption.value;
                                                    setExperienceToUpdate(
                                                      (prevState) => {
                                                        return {
                                                          ...prevState,
                                                          jobType: val,
                                                        };
                                                      }
                                                    );
                                                  }}
                                                />
                                              </div>
                                              <div className="form-group col-md-6">
                                                <label>De</label>
                                                <input
                                                  value={moment(
                                                    experienceToUpdate.startDate
                                                  )?.format("YYYY-MM-DD")}
                                                  type="date"
                                                  className="form-control"
                                                  id="startDate"
                                                  placeholder=""
                                                  onChange={(e) => {
                                                    let val = e.target?.value;
                                                    let match = isMatch(
                                                      e.target.value,
                                                      "yyyy-MM-dd"
                                                    );
                                                    setExperienceToUpdate(
                                                      (prevState) => {
                                                        return {
                                                          ...prevState,
                                                          startDate: val,
                                                        };
                                                      }
                                                    );
                                                    if (match && val != "") {
                                                      setInvalideDate(!match);
                                                    }
                                                  }}
                                                  onBlur={(e) => {
                                                    let val = isMatch(
                                                      e.target.value,
                                                      "yyyy-MM-dd"
                                                    );
                                                    if (e.target.value != "") {
                                                      setInvalideDate(!val);
                                                    }
                                                    if (!val) {
                                                      setExperienceToUpdate(
                                                        (prevState) => {
                                                          return {
                                                            ...prevState,
                                                            startDate: "",
                                                          };
                                                        }
                                                      );
                                                    }
                                                  }}
                                                />
                                                {invalideDate && (
                                                  <p style={{ color: "red" }}>
                                                    Format invalide
                                                  </p>
                                                )}
                                              </div>
                                              <div className="form-group col-md-6">
                                                <label>À</label>
                                                <input
                                                  value={moment(
                                                    experienceToUpdate.endDate
                                                  )?.format("YYYY-MM-DD")}
                                                  type="date"
                                                  className="form-control"
                                                  id="endDate"
                                                  placeholder=""
                                                  onChange={(e) => {
                                                    let val = e.target?.value;
                                                    let match = isMatch(
                                                      e.target.value,
                                                      "yyyy-MM-dd"
                                                    );
                                                    setExperienceToUpdate(
                                                      (prevState) => {
                                                        return {
                                                          ...prevState,
                                                          endDate: val,
                                                        };
                                                      }
                                                    );
                                                    if (match && val !== "") {
                                                      setInvalideDate(!match);
                                                    }
                                                  }}
                                                  onBlur={(e) => {
                                                    let val = isMatch(
                                                      e.target.value,
                                                      "yyyy-MM-dd"
                                                    );
                                                    if (e.target.value !== "") {
                                                      setInvalideDate(!val);
                                                    }
                                                    if (!val) {
                                                      setExperienceToUpdate(
                                                        (prevState) => {
                                                          return {
                                                            ...prevState,
                                                            endDate: "",
                                                          };
                                                        }
                                                      );
                                                    }
                                                  }}
                                                />
                                                {invalideDate && (
                                                  <p style={{ color: "red" }}>
                                                    Format invalide
                                                  </p>
                                                )}
                                              </div>

                                              <div className="form-group col-md-12">
                                                <label>Description</label>
                                                <textarea
                                                  value={
                                                    experienceToUpdate.description
                                                  }
                                                  type="text"
                                                  className="form-control"
                                                  id="description"
                                                  placeholder=""
                                                  onChange={(e) => {
                                                    let val = e.target?.value;
                                                    setExperienceToUpdate(
                                                      (prevState) => {
                                                        return {
                                                          ...prevState,
                                                          description: val,
                                                        };
                                                      }
                                                    );
                                                  }}
                                                ></textarea>
                                              </div>
                                              <div className="col-12 mt-4">
                                                <button
                                                  className="btn btn-primary"
                                                  onClick={
                                                    handleUpdateExperienceSubmit
                                                  }
                                                  disabled={
                                                    isExperienceUpdating
                                                  }
                                                  style={{
                                                    textAlign: "right",
                                                    float: "right",
                                                  }}
                                                >
                                                  Mettre à jour &nbsp;{" "}
                                                  {isExperienceUpdating ? (
                                                    <CircularProgress
                                                      size={15}
                                                    />
                                                  ) : (
                                                    <span></span>
                                                  )}
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Start Delete  modale */}
        <div
          className="modal fade"
          id="deleteExperience"
          tabIndex="-1"
          role="dialog"
          aria-modal="true"
        >
          <div
            className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header p-4">
                <h4 className="mb-0 text-center">
                  Suppression d'une expérience profesionnelle
                </h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <form className="mt-2">
                <div className="modal-body">
                  <div>
                    <div className="form-row">
                      <p>
                        Voulez vous supprimer cette expérience:{" "}
                        {experienceTodelete?.title}?
                      </p>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    data-dismiss="modal"
                    className="btn btn-primary"
                    ref={closeDeleteExperienceModal}
                  >
                    NON
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleDeleteExperienceSubmit}
                    disabled={isExperienceDeletting}
                  >
                    OUI &nbsp;{" "}
                    {isExperienceDeletting ? (
                      <CircularProgress size={15} />
                    ) : (
                      <span></span>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* End Delete  modale */}
      </div>
    </React.Fragment>
  );
};

ExperienceReume.propTypes = {
  addCandidateExperience: PropTypes.func.isRequired,
  deleteCandidateExperience: PropTypes.func.isRequired,
  updateCandidateExperience: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  addCandidateExperience: PropTypes.func.isRequired,
  deleteCandidateExperience: PropTypes.func.isRequired,
  updateCandidateExperience: PropTypes.func.isRequired,
});

export default connect(mapStateToProps, {
  addCandidateExperience,
  deleteCandidateExperience,
  updateCandidateExperience,
})(ExperienceReume);
